import { Info, OctagonAlert, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

type Tone = "info" | "warning" | "error";

interface StateBannerProps {
  tone?: Tone;
  children: ReactNode;
  action?: { label: string; onClick: () => void };
}

const toneClass: Record<Tone, string> = {
  info: "border-l-wing",
  warning: "border-l-bnb",
  error: "border-l-ember",
};

const iconColor: Record<Tone, string> = {
  info: "text-wing",
  warning: "text-bnb",
  error: "text-ember",
};

function ToneIcon({ tone }: { tone: Tone }) {
  const className = `w-5 h-5 shrink-0 ${iconColor[tone]}`;
  switch (tone) {
    case "info":
      return <Info className={className} strokeWidth={1.75} aria-hidden />;
    case "warning":
      return <TriangleAlert className={className} strokeWidth={1.75} aria-hidden />;
    case "error":
      return <OctagonAlert className={className} strokeWidth={1.75} aria-hidden />;
  }
}

export function StateBanner({ tone = "info", children, action }: StateBannerProps) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      className={`glass border-l-4 ${toneClass[tone]} p-3 flex items-start gap-3`}
    >
      <ToneIcon tone={tone} />
      <div className="flex-1 min-w-0 text-sm text-ink leading-relaxed pt-0.5">{children}</div>
      {action ? (
        <button type="button" className="btn-ghost shrink-0 !py-1.5" onClick={action.onClick}>
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
